import api from '@/plugins/api'
import { client, directory } from '@/configs/endpoints'
import requestValidation from '@/configs/requestValidation'
const store = 'client'

export default {
  state: () => ({
    client: null,
    clientPassport: null,
    foundClient: [],
    foundClientOpened: '',
    chooseClient: {},
    isLoad: false
  }),
  actions: {
    async findClient (context, body) {
      const params = new URLSearchParams()
      params.append('last_name_ukr', body.last_name_ukr)
      params.append('first_name_ukr', body.first_name_ukr)
      params.append('middle_name_ukr', body.middle_name_ukr)
      params.append('date_birth', body.date_birth)

      const response = await api.get(`${ client.client }?${ params }`)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'foundClient', data: response.data.results })
      }
    },
    async getClient (context, id) {
      const response = await api.get(client.clientById(id))
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'client', data: response.data })
      }
    },
    async setClient (context, body) {
      const response = await api.post(client.client, { body: body })
      if (await requestValidation(response)) {
        return response.data.id
      }
      return false
    },
    async setPassport(context, data) {
      const response = await api.post(client.passport(data.id), { body: data.body })
      return requestValidation(response)
    },
    async getClientPassport(context, data) {
      const response = await api.get(client.passport(data.id))
      if (await requestValidation(response)) {
        if (data.save) {
          response.data.results.length &&
          context.commit('ADD_PASSPORT_TO_CLIENTS', {
            store,
            state: 'foundClient',
            data: { id: data.id, passport: response.data.results[0] }
          })
        }
        if (data.setState) {
          context.commit('SET_DATA', { store, state: 'clientPassport', data: response.data.results[0] })
        }
        return response.data.results[0]
      } return false
    },
    async setNewCity(context, data) {
      const response = await api.post(directory.city(), { body: data })
      if (requestValidation(response.data)) {
        return response.data
      } else {
        return false
      }
    },
    setClientAddress (context, data) {
      context.commit('SET_DATA', { store, state: 'foundClientOpened', data: data })
    }
  }
}
